import { render, staticRenderFns } from "./GroupDataTable.vue?vue&type=template&id=bc3d3b3c&scoped=true"
import script from "./GroupDataTable.vue?vue&type=script&lang=js"
export * from "./GroupDataTable.vue?vue&type=script&lang=js"
import style0 from "./GroupDataTable.vue?vue&type=style&index=0&id=bc3d3b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d3b3c",
  null
  
)

export default component.exports